import { render, staticRenderFns } from "./ProgramReports.vue?vue&type=template&id=3f150790&"
import script from "./ProgramReports.vue?vue&type=script&lang=ts&"
export * from "./ProgramReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports